import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Player } from 'ThreeTerminal_mobile_dynamic';
import { h5PageCount, cookieUtil, mos } from 'ThreeTerminal_utils';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { callApp } from '@ifeng-fe/callapp';
import { formatImageAblur } from 'ThreeTerminal_base/publicMethod';

let pageWidth = 375;

if (typeof document === 'object') {
    pageWidth = document.documentElement.clientWidth > 812 ? 812 : document.documentElement.clientWidth;
}

const videoWidth = Math.floor((pageWidth * 9) / 16);
const MIN_ASPECT_RATIO = 3 / 4;
const MAX_ASPECT_RATIO = 16 / 9;
// let vedioPlayDom = {};

class Video extends React.PureComponent {
    static propTypes = {
        videoConfig: PropTypes.object,
        pageInfo: PropTypes.object,
        pageType: PropTypes.string,
    };

    state = {
        isShowVideoFix: false,
        playerHeight: videoWidth,
        playerWidth: pageWidth,
    };

    videoWrapperRef = React.createRef();

    playermsg = {
        auth: true,
        showTitle: false,
        showPoster: true,
        showController: true,
        height: this.state.playerHeight,
        isInsertArticle: true
    };

    componentDidMount() {
        this.updatePlayerHeight();
        if (typeof window === 'object') {
            window.addEventListener('resize', this.updatePlayerHeight);
        }
    }

    componentWillUnmount() {
        if (typeof window === 'object') {
            window.removeEventListener('resize', this.updatePlayerHeight);
        }
    }

    getAspectRatio = (aspect) => {
        if (!aspect || typeof aspect !== 'string') return 0;
        const [width, height] = aspect.split(':').map(Number);

        if (!width || !height) return 0;

        return width / height;
    };

    getPlayerHeight = (playerWidth, aspect) => {
        if (!playerWidth) return videoWidth;

        const originAspectRatio = this.getAspectRatio(aspect);

        if (!originAspectRatio) {
            return Math.floor((playerWidth * 9) / 16);
        }

        let limitedAspectRatio = originAspectRatio;

        if (originAspectRatio > MAX_ASPECT_RATIO) {
            // console.log('111', aspect, originAspectRatio, MAX_ASPECT_RATIO);
            limitedAspectRatio = MAX_ASPECT_RATIO;
        } else if (originAspectRatio <= MAX_ASPECT_RATIO && originAspectRatio >= MIN_ASPECT_RATIO) {
            // console.log('222', aspect, originAspectRatio, MIN_ASPECT_RATIO);
            limitedAspectRatio = originAspectRatio;
        } else if (originAspectRatio < MIN_ASPECT_RATIO) {
            // console.log('333', aspect, originAspectRatio, MIN_ASPECT_RATIO, MAX_ASPECT_RATIO);
            limitedAspectRatio = MIN_ASPECT_RATIO;
        }

        return Math.floor(playerWidth / limitedAspectRatio);
    };

    updatePlayerHeight = () => {
        const playerWidth = this.videoWrapperRef.current && this.videoWrapperRef.current.clientWidth;

        // console.log(playerWidth, 'playerWidth');
        const aspect = (this.props.videoConfig && this.props.videoConfig.aspect) || '';
        const playerHeight = this.getPlayerHeight(playerWidth, aspect);

        if (playerHeight !== this.state.playerHeight) {
            this.setState({
                playerHeight,
                playerWidth,
            });
        }
    };

    handleClick = (isCount) => {
        const { pageInfo } = this.props;
        const doc_type = pageInfo.type === 'article' ? 'doc' : pageInfo.type;
        const aid = pageInfo._id || pageInfo.base62Id;
        const client = pageInfo.isVideoShare ? 'videoApp' : 'newsApp';

        if (isCount) h5PageCount([pageInfo.actionCount]);
        callApp({
            client,
            docType: doc_type,
            pid: aid,
            kind: 'default_videohike',
        });
    };

    UNSAFE_componentWillMount() {
        const { pageInfo } = this.props;

        if (pageInfo && pageInfo.clickCount) {
            this.playermsg.clickVideoStatisticsCB = () => {
                h5PageCount([pageInfo.clickCount]);
            };
        }
        if (pageInfo && pageInfo.firstPlayCount) {
            this.playermsg.firstFrameStatisticsCB = () => {
                h5PageCount([pageInfo.firstPlayCount]);
            };
        }

        // if (pageInfo && pageInfo.clickGotoCount && mos() === 'android') {
        //     if (!cookieUtil.get('videoFixBox')) {
        //         this.playermsg.beforePlayCB = exposeApis => {
        //             exposeApis.pause();
        //             vedioPlayDom = exposeApis;
        //             this.setState(
        //                 {
        //                     isShowVideoFix: true,
        //                 },
        //                 () => {
        //                     h5PageCount([pageInfo.clickVideoBoxCount]);
        //                 },
        //             );
        //         };
        //     }
        // }
    }

    // handleLaterFn = () => {
    //     const { pageInfo } = this.props;
    //     const exp = new Date();

    //     exp.setTime(exp.getTime() + 2 * 24 * 60 * 60 * 1000);
    //     cookieUtil.set('videoFixBox', 1, exp);
    //     this.setState({
    //         isShowVideoFix: false,
    //     });
    //     vedioPlayDom.play();

    //     h5PageCount([pageInfo.clickLaterCount]);
    // };

    // handleGotoFn = () => {
    //     const { pageInfo } = this.props;

    //     this.handleClick(false);
    //     h5PageCount([pageInfo.clickGotoCount]);
    // };

    render() {
        const { videoConfig, pageInfo, pageType } = this.props;
        const { playerWidth, playerHeight } = this.state;

        // const { isShowVideoFix } = this.state;
        this.playermsg.height = playerHeight;

        if (videoConfig.title) this.playermsg.tips = videoConfig.title;
        // if (pageInfo) this.playermsg.tips = false;
        this.playermsg.tips = false;

        const callUpDom = pageInfo && (
            <section className={styles.callUpBox} onClick={this.handleClick.bind(this, true)}>
                {!pageInfo.isVideoShare && <div className={styles.title}>打开凤凰新闻客户端 提升3倍流畅度</div>}
                {pageInfo.isVideoShare && <div className={styles.title}>打开凤凰视频客户端 提升3倍流畅度</div>}
            </section>
        );
        // const videoFixDom = isShowVideoFix && (
        //     <section className={styles.videoFixbox}>
        //         <section className={styles.videoFixBorder}>
        //             {!pageInfo.isVideoShare && <p className={styles.videoFixTitle}>打开凤凰新闻</p>}
        //             {pageInfo.isVideoShare && <p className={styles.videoFixTitle}>打开凤凰视频</p>}
        //             <p className={styles.videoFixTitle}>观看更流畅</p>
        //             <div className={styles.videoFixButton}>
        //                 <div className={styles.videoFixItem} onClick={this.handleLaterFn}>
        //                     稍后
        //                 </div>
        //                 <div className={styles.videoFixItem} onClick={this.handleGotoFn}>
        //                     立即前往
        //                 </div>
        //             </div>
        //         </section>
        //     </section>
        // );

        videoConfig.bigPosterUrl =
            (videoConfig.bigPosterUrl && formatImageAblur(videoConfig.bigPosterUrl, playerWidth * 2, playerHeight * 2)) || '';
        
        // videoConfig.title = ''; 

        return (
            <div
                className={`${styles.video} ${pageType === 'short' ? styles.videoShort : ''}`}
                ref={this.videoWrapperRef}>
                <Player videoConfig={videoConfig} playermsg={this.playermsg} />
                {callUpDom}

                {/* {videoFixDom} */}
            </div>
        );
    }
}

export default errorBoundary(Video);
